"use client";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OuterFrame from "../../common/OuterFrame";
import { Oval } from "react-loader-spinner";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SidebarOverlay from "../../Sidebar";
import ConcentForm from "../../common/PaitentConcent";
import Cookies from "js-cookie";

import {
  faUser,
  faRuler,
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
  faIdBadge,
  faBirthdayCake,
  faVenusMars,
  faWeight,
  faBalanceScale,
  faHeartbeat,
  faArrowUp,
  faArrowDown,
  faLungs,
} from "@fortawesome/free-solid-svg-icons";
import PopupContainer from "../../PopupContainer";
import { getMaxDate } from "../../../utils/apiUtils";

const COPDComponent = (props) => {
  const navigate = useNavigate();
  const [loaderstatus, setLoaderStatus] = useState(true); // Start with true
  const [isDataReady, setIsDataReady] = useState(false);
  const [patientInfo, setPatientInfo] = useState({});
  const [formData, setFormData] = useState({});
  const [warningMessage, setWarningMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [activeId, setActiveId] = useState(null);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [aqiInfo, setAqiInfo] = useState({
    value: null,
    loading: false,
    error: null,
  });

  const isEmptyValue = (value) => {
    return value === undefined || value === null || value === "";
  };

  const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
  const PHONE_REGEX = /^(\+91)?[6-9]\d{9}$/;
  const EMAIL_ERROR = "Please enter a valid email address (e.g., user@example.com)";
  const PHONE_ERROR = "Please enter a valid 10-digit phone number (e.g., +91 9876543210 or 9876543210)";
  const isEmailKey = (key) => /^e-?mail/i.test(key);
  const isValidEmail = (v) => EMAIL_REGEX.test(v) && !v.includes("..");

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    patientInfo.Patient_Details?.forEach((field) => {
      const val = formData[field.key];
      if (field.required === "yes" && isEmptyValue(val)) {
        errors[field.key] = "This field is required";
        isValid = false;
      } else if (!isEmptyValue(val) && typeof val === "string") {
        if (isEmailKey(field.key) && !isValidEmail(val.trim())) {
          errors[field.key] = EMAIL_ERROR;
          isValid = false;
        } else if (field.key === "phone" && !PHONE_REGEX.test(val.replace(/\s/g, ""))) {
          errors[field.key] = PHONE_ERROR;
          isValid = false;
        }
      }
    });

    patientInfo.Attributes?.[0]["Physical Attributes"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required";
        isValid = false;
      }
    });

    patientInfo.Attributes?.[1]["AQI"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required";
        isValid = false;
      }
    });

    patientInfo.Attributes?.[2]["CLINICAL PARAMETERS & HISTORY"]?.forEach(
      (field) => {
        if (field.required === "yes" && isEmptyValue(formData[field.key])) {
          errors[field.key] = "This field is required";
          isValid = false;
        }
      }
    );

    patientInfo.Attributes?.[3]["MEDICATION HISTORY"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required";
        isValid = false;
      }
    });
    patientInfo.Attributes?.[4]["CLINICAL EXAMINATIONS"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required";
        isValid = false;
      }
    });

    setValidationErrors(errors);
    return isValid;
  };

  const toggleSidebar = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const fetchAQIData = async (pincode) => {
    setAqiInfo((prev) => ({ ...prev, loading: true, error: null }));

    try {
      const url = `${props.COPD_AQI_URL}${pincode}`;
      const jwt_token = Cookies.get("jwt_token");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${jwt_token}`);
      const options = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(url, options);
      const responseObj = await response.json();
      if (response.status === 200) {
        let airIndex = "undefined";
        if (responseObj !== undefined) {
          airIndex = responseObj.aqi_response.globalIndex;
        }
        setAqiInfo({
          value: airIndex,
          loading: false,
          error: null,
        });

        setFormData((prev) => ({
          ...prev,
          airIndex: Number.parseFloat(airIndex),
        }));
      } else {
        alert("Failed to fetch the data");
      }
    } catch (error) {
      setAqiInfo({
        value: null,
        loading: false,
        error: "Failed to fetch AQI data. Please try again.",
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setWarningMessage("");
    if (!validateForm()) {
      setWarningMessage("Please fill in all required fields");
      return;
    } else {
      props.form_details && props.form_details(formData);
      navigate(`/copd/report`);
    }
  };
  const findFieldByKey = (key) => {
    // Search in Patient Details
    const patientField = patientInfo.Patient_Details?.find(
      (f) => f.key === key
    );
    if (patientField) return patientField;

    // Search in Physical Attributes
    const physicalField = patientInfo.Attributes?.[0][
      "Physical Attributes"
    ]?.find((f) => f.key === key);
    if (physicalField) return physicalField;

    const aqiField = patientInfo.Attributes?.[1]["AQI"]?.find(
      (f) => f.key === key
    );
    if (aqiField) return aqiField;

    const clinicalFields = patientInfo.Attributes?.[2][
      "CLINICAL PARAMETERS & HISTORY"
    ]?.find((f) => f.key === key);
    if (clinicalFields) return clinicalFields;

    const medicalFields = patientInfo.Attributes?.[3][
      "MEDICATION HISTORY"
    ]?.find((f) => f.key === key);
    if (medicalFields) return medicalFields;

    const examinationFields = patientInfo.Attributes?.[3][
      "CLINICAL EXAMINATIONS"
    ]?.find((f) => f.key === key);
    if (examinationFields) return examinationFields;

    // If no field is found
    return null;
  };

  const handleInputChange = (key, value) => {
    const field = findFieldByKey(key)

    if ((isEmailKey(key) || key === "phone") && value === "") {
      // Clearing the field must also clear any stale format error
      setValidationErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[key];
        return newErrors;
      });
    }

    if (isEmailKey(key) && value !== "") {
      value = value.trim();
      if (!isValidEmail(value)) {
        setValidationErrors((prev) => ({
          ...prev,
          [key]: EMAIL_ERROR,
        }));
      } else {
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[key]
          return newErrors
        })
      }
    }

    if (key === "phone" && value !== "") {
      // Remove any spaces for validation
      const cleanedValue = value.replace(/\s/g, "")
      const phoneRegex = /^(\+91)?[6-9]\d{9}$/

      if (!phoneRegex.test(cleanedValue)) {
        setValidationErrors((prev) => ({
          ...prev,
          [key]: "Please enter a valid 10-digit phone number (e.g., +91 9876543210 or 9876543210)",
        }))
      } else {
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[key]
          return newErrors
        })
      }
    }

    if (key === "aqi" && value !== "") {
      const pincodeRegex = /^\d{0,6}$/
      if (!pincodeRegex.test(value)) {
        // Don't update the value if it contains non-numeric characters
        return
      }

      if (value.length === 6) {
        fetchAQIData(value)
      } else {
        setAqiInfo({ value: null, loading: false, error: null })
      }
    }

    if (field?.ranges && value !== "") {
      const numValue = Number(value)
      if (isNaN(numValue)) {
        // If not a number, don't update the value
        return
      }

      if (
        numValue < field.ranges[0] ||
        numValue > field.ranges[1] ||
        (key.toLowerCase() === "age" && !Number.isInteger(numValue))
      ) {
        // Show validation error but still allow typing
        setValidationErrors((prev) => ({
          ...prev,
          [key]: key.toLowerCase() === "age" && !Number.isInteger(numValue)
            ? "Age must be an integer"
            : `Value must be between ${field.ranges[0]} and ${field.ranges[1]}`,
        }))
      } else {
        // Clear validation error if value is in range
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[key]
          return newErrors
        })
      }
    }

    // Always update the form data
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  useEffect(() => {
    const initializeData = async () => {
      setLoaderStatus(true);
      try {
        const savedContent = JSON.parse(localStorage.getItem("fields"));
        if (savedContent) {
          setPatientInfo(savedContent);
          setIsDataReady(true);
        }
      } catch (error) {
      } finally {
        setTimeout(() => {
          setLoaderStatus(false);
        }, 500);
      }
    };

    initializeData();
  }, [props.app]);

  const handleOptionChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const renderClinicalParameters = (clinicalData) => {
    if (!clinicalData) return null;

    // Group fields in pairs for side-by-side layout
    const groupedFields = [];
    for (let i = 0; i < clinicalData.length; i += 2) {
      groupedFields.push(clinicalData.slice(i, i + 2));
    }

    return (
      <div className="copd-attributes-clinical-form">
        {groupedFields.map((fieldGroup, groupIndex) => (
          <div key={groupIndex} className="copd-attributes-clinical-row">
            {fieldGroup.map((item, index) => (
              <div key={index} className="copd-attributes-clinical-field-side">
                <div className="copd-attributes-clinical-field-header">
                  <h4 className="copd-attributes-clinical-field-label">
                    {item.name}
                    {item.required === "yes" && (
                      <span className="copd-attributes-required">*</span>
                    )}
                    {item.description && item.description !== "" && (
                      <span>
                        <button
                          type="button"
                          onClick={() => toggleSidebar(item.name)}
                          className="description-bar"
                        >
                          i
                        </button>
                        {activeId === item.name && (
                          <SidebarOverlay
                            id={item.name}
                            description={item.description}
                            activeId={activeId}
                            name={item.name}
                            setActiveId={setActiveId}
                            toggleSidebar={toggleSidebar}
                          />
                        )}
                      </span>
                    )}
                  </h4>
                </div>

                {(item.type === "select" || item.type === "box") && (
                  <div className="copd-attributes-clinical-options">
                    {item.options.map((option, optIndex) => (
                      <button
                        key={optIndex}
                        type="button"
                        onClick={() =>
                          handleOptionChange(item.key, option.value)
                        }
                        className={`copd-attributes-clinical-option-button ${formData[item.key] === option.value ? "active" : ""
                          } ${validationErrors[item.key] ? "error" : ""}`}
                      >
                        {option.name}
                      </button>
                    ))}
                  </div>
                )}

                {item.additional_info && (
                  <div className="copd-attributes-medication-info">
                    <p className="copd-attributes-medication-group">
                      {item.additional_info.group2}
                    </p>
                    <p className="copd-attributes-medication-group">
                      {item.additional_info.group3}
                    </p>
                  </div>
                )}

                {validationErrors[item.key] && (
                  <span className="copd-attributes-error-message">
                    {validationErrors[item.key]}
                  </span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const renderMedicationHistory = (medicationData) => {
    if (!medicationData) return null;

    // Group fields in pairs for side-by-side layout
    const groupedFields = [];
    for (let i = 0; i < medicationData.length; i += 2) {
      groupedFields.push(medicationData.slice(i, i + 2));
    }

    return (
      <div className="copd-attributes-medical-form">
        {groupedFields.map((fieldGroup, groupIndex) => (
          <div key={groupIndex} className="copd-attributes-medical-row">
            {fieldGroup.map((item, index) => (
              <div key={index} className="copd-attributes-clinical-field-side">
                <div className="copd-attributes-clinical-field-header">
                  <h4 className="copd-attributes-clinical-field-label">
                    {item.name}
                    {item.required === "yes" && (
                      <span className="copd-attributes-required">*</span>
                    )}
                  </h4>
                </div>

                {/* Button-style options for select and box types */}
                {(item.type === "select" || item.type === "box") && (
                  <div className="copd-attributes-clinical-options">
                    {item.options.map((option, optIndex) => (
                      <button
                        key={optIndex}
                        type="button"
                        onClick={() =>
                          handleOptionChange(item.key, option.value)
                        }
                        className={`copd-attributes-clinical-option-button ${formData[item.key] === option.value ? "active" : ""
                          } ${validationErrors[item.key] ? "error" : ""}`}
                      >
                        {option.name}
                      </button>
                    ))}
                  </div>
                )}

                {item.info && (
                  <div className="copd-attributes-medication-info">
                    <p className="copd-attributes-medication-group">
                      {item.info[0]}
                    </p>
                    <p className="copd-attributes-medication-group">
                      {item.info[1]}
                    </p>
                  </div>
                )}

                {validationErrors[item.key] && (
                  <span className="copd-attributes-error-message">
                    {validationErrors[item.key]}
                  </span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const renderField = (item, index) => {
    const hasError = validationErrors[item.key];
    const fieldValue = formData[item.key] || "";

    return (
      <div key={index} className="copd-attributes-card">
        <div className="copd-attributes-field-header">
          <p className="copd-attributes-field-label">
            {item.name}
            {item.required === "yes" && (
              <span className="copd-attributes-required">*</span>
            )}
          </p>
        </div>

        {item.type === "radio" && (
          <div className="copd-attributes-radio-group">
            {item.options.map((option, optIndex) => (
              <div key={optIndex} className="copd-attributes-radio-item">
                <div className="copd-attributes-radio-wrapper">
                  <input
                    type="radio"
                    id={`${item.key}-${optIndex}`}
                    name={item.key}
                    value={option.value}
                    checked={fieldValue === option.value}
                    onChange={(e) =>
                      handleOptionChange(item.key, e.target.value)
                    }
                    className="copd-attributes-radio-input"
                  />
                  <span className="copd-radio"></span>
                  <label
                    htmlFor={`${item.key}-${optIndex}`}
                    className="copd-attributes-radio-label"
                  >
                    {option.name}
                  </label>
                </div>
                {option.sub_options && formData[item.key] === option.value && (
                  <div className="copd-attributes-radio-sub-options">
                    {option.sub_options.map((subOption, subIndex) => (
                      <div key={subIndex}>
                        <label className="copd-attributes-sub-label">
                          {subOption.name}
                        </label>
                        <textarea
                          placeholder={`Enter ${subOption.name.toLowerCase()}`}
                          value={formData[subOption.key] || ""}
                          onChange={(e) =>
                            handleInputChange(subOption.key, e.target.value)
                          }
                          className="copd-attributes-textarea"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {item.type === "select" && (
          <div className="copd-attributes-select-wrapper">
            <select
              name={item.key}
              value={fieldValue}
              onChange={(e) => handleOptionChange(item.key, e.target.value)}
              className={`copd-attributes-select ${hasError ? "error" : ""}`}
            >
              <option value="">Select an option</option>
              {item.options.map((option, optIndex) => (
                <option key={optIndex} value={option.value}>
                  {option.name}
                </option>
              ))}
            </select>

            {/* Handle sub-options for select fields */}
            {item.options.map(
              (option) =>
                option.sub_options &&
                formData[item.key] === option.value && (
                  <div
                    key={option.value}
                    className="copd-attributes-sub-options"
                  >
                    {option.sub_options.map((subOption, subIndex) => (
                      <div key={subIndex}>
                        <label className="copd-attributes-sub-label">
                          {subOption.name}
                        </label>
                        <textarea
                          placeholder={`Enter ${subOption.name.toLowerCase()}`}
                          value={formData[subOption.key] || ""}
                          onChange={(e) =>
                            handleInputChange(subOption.key, e.target.value)
                          }
                          className="copd-attributes-textarea"
                        />
                      </div>
                    ))}
                  </div>
                )
            )}
          </div>
        )}

        {item.type === "text" && (
          <div className="copd-attributes-text-wrapper">
            <input
              type="text"
              name={item.key}
              value={fieldValue}
              onChange={(e) => handleInputChange(item.key, e.target.value)}
              className={`copd-attributes-text-input ${hasError ? "error" : ""
                }`}
              placeholder={
                item.key === "aqi" ? "Enter 6-digit pincode" : "Enter text"
              }
              maxLength={item.key === "aqi" ? 6 : undefined}
            />
          </div>
        )}

        {item.type === "date" && (
          <div className="copd-attributes-date-wrapper">
            <input
              type="date"
              value={fieldValue}
              onChange={(e) => handleInputChange(item.key, e.target.value)}
              className={`copd-attributes-date-input ${hasError ? "error" : ""
                }`}
              max={getMaxDate()}
            />
          </div>
        )}

        {hasError && (
          <span className="copd-attributes-error-message">
            {validationErrors[item.key]}
          </span>
        )}
      </div>
    );
  };

  const renderAttributes = (attributes, section) => {
    if (!attributes) return null;

    // Separate items by type
    const radioItems = attributes.filter((item) => item.type === "radio");
    const selectItems = attributes.filter((item) => item.type === "select");
    const dateItems = attributes.filter((item) => item.type === "date");

    // Find COVID-related items
    const covidVaccineItem = selectItems.find(
      (item) => item.key === "covid_vaccine_brand"
    );
    const covidDateItem = dateItems.find(
      (item) => item.key === "covid_vaccine_date"
    );

    // Filter out COVID items from their respective arrays
    const otherSelectItems = selectItems.filter(
      (item) => item.key !== "covid_vaccine_brand"
    );
    const otherDateItems = dateItems.filter(
      (item) => item.key !== "covid_vaccine_date"
    );

    return (
      <div className="copd-attributes-form">
        {/* Radio Items */}
        <div className="copd-attributes-grid copd-attributes-grid-single">
          {radioItems.map((item, index) => renderField(item, index))}
        </div>

        {/* Select Items (excluding COVID vaccine) */}
        <div className="copd-attributes-grid copd-attributes-grid-double">
          {otherSelectItems.map((item, index) => renderField(item, index))}
        </div>

        {/* COVID-19 Section - Side by Side */}
        {(covidVaccineItem || covidDateItem) && (
          <div className="copd-attributes-covid-section">
            <h3 className="copd-attributes-covid-title">
              COVID-19 Vaccination Information
            </h3>
            <div className="copd-attributes-covid-grid">
              {covidVaccineItem && (
                <div className="copd-attributes-covid-field">
                  <div className="copd-attributes-field-header">
                    <label className="copd-attributes-field-label">
                      {covidVaccineItem.name}
                      {covidVaccineItem.required === "yes" && (
                        <span className="copd-attributes-required">*</span>
                      )}
                    </label>
                  </div>
                  <select
                    name={covidVaccineItem.key}
                    value={formData[covidVaccineItem.key] || ""}
                    onChange={(e) =>
                      handleOptionChange(covidVaccineItem.key, e.target.value)
                    }
                    className={`copd-attributes-select ${validationErrors[covidVaccineItem.key] ? "error" : ""
                      }`}
                  >
                    <option value="">Select vaccine brand</option>
                    {covidVaccineItem.options.map((option, optIndex) => (
                      <option key={optIndex} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {validationErrors[covidVaccineItem.key] && (
                    <span className="copd-attributes-error-message">
                      {validationErrors[covidVaccineItem.key]}
                    </span>
                  )}
                </div>
              )}

              {covidDateItem && (
                <div className="copd-attributes-covid-field">
                  <div className="copd-attributes-field-header">
                    <label className="copd-attributes-field-label">
                      {covidDateItem.name}
                      {covidDateItem.required === "yes" && (
                        <span className="copd-attributes-required">*</span>
                      )}
                    </label>
                  </div>
                  <div className="copd-attributes-date-wrapper">
                    <input
                      type="date"
                      value={formData[covidDateItem.key] || ""}
                      onChange={(e) =>
                        handleInputChange(covidDateItem.key, e.target.value)
                      }
                      className={`copd-attributes-date-input ${validationErrors[covidDateItem.key] ? "error" : ""
                        }`}
                      max={getMaxDate()}
                    />
                  </div>
                  {validationErrors[covidDateItem.key] && (
                    <span className="copd-attributes-error-message">
                      {validationErrors[covidDateItem.key]}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="copd-attributes-grid copd-attributes-grid-double">
          {otherDateItems.map((item, index) => renderField(item, index))}
        </div>
      </div>
    );
  };

  const renderAQI = (aqiData) => {
    if (!aqiData) return null;

    return (
      <div className="copd-attributes-form">
        <div className="copd-attributes-grid copd-attributes-grid-single">
          {aqiData.map((item, index) => (
            <div key={index}>
              {renderField(item, index)}

              {item.key === "aqi" && (
                <div className="copd-attributes-aqi-result">
                  {aqiInfo.loading && (
                    <div className="copd-attributes-aqi-loading">
                      <span>Fetching AQI data...</span>
                    </div>
                  )}

                  {aqiInfo.error && (
                    <div className="copd-attributes-aqi-error">
                      <span>{aqiInfo.error}</span>
                    </div>
                  )}

                  {aqiInfo.value !== null &&
                    !aqiInfo.loading &&
                    !aqiInfo.error && (
                      <div className="copd-attributes-aqi-value">
                        <span>
                          The location's average air quality index is:{" "}
                          <strong>{aqiInfo.value}</strong>
                        </span>
                      </div>
                    )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const getIconForField = (fieldName) => {
    switch (fieldName.toLowerCase()) {
      case "email":
        return faEnvelope;
      case "location":
        return faMapMarkerAlt;
      case "phone":
        return faPhone;
      case "uhid":
        return faIdBadge;
      case "name":
        return faUser;
      case "age":
        return faBirthdayCake;
      case "gender":
        return faVenusMars;
      case "height":
        return faRuler;
      case "weight":
        return faWeight;
      case "bmi":
        return faBalanceScale;
      case "heart rate": // Added for Heart Rate
        return faHeartbeat;
      case "systolic bp": // Added for Systolic Blood Pressure
        return faArrowUp;
      case "diastolic bp": // Added for Diastolic Blood Pressure
        return faArrowDown;
      case "respiration rate": // Added for Respiration Rate
        return faLungs;
      default:
        return faUser;
    }
  };

  const handleFieldFocus = (key) => {
    // Format errors (email/phone) must persist until the value is actually fixed
    if (isEmailKey(key) || key === "phone") return;
    if (validationErrors[key]) {
      setValidationErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[key];
        return newErrors;
      });
    }
  };

  const getPlaceholderText = (field) => {
    if (field.ranges) {
      return `${field.ranges[0]} - ${field.ranges[1]}`;
    }
    return "";
  };

  const handleCheckboxChange = (checkboxId) => {
    if (checkboxId === 1) {
      setIsChecked1((prev) => !prev);
    }
  };

  const renderClinicalExaminationField = (item, index) => {
    const hasError = validationErrors[item.key];
    const fieldValue = formData[item.key] || "";

    return (
      <div key={index} className="copd-clinical-examination-field">
        <div className="copd-clinical-examination-field-header">
          <h4 className="copd-clinical-examination-field-label">
            {item.name}
            {item.required === "yes" && (
              <span className="copd-clinical-examination-required">*</span>
            )}
          </h4>
        </div>

        {/* Button-style options for select and box types */}
        {(item.type === "select" || item.type === "box") && (
          <div className="copd-clinical-examination-options">
            {item.options.map((option, optIndex) => (
              <button
                key={optIndex}
                type="button"
                onClick={() => handleOptionChange(item.key, option.value)}
                className={`copd-clinical-examination-option-button ${fieldValue === option.value ? "active" : ""
                  } ${hasError ? "error" : ""}`}
              >
                {option.name}
              </button>
            ))}
          </div>
        )}

        {/* Number input fields */}
        {item.type === "number" && (
          <div className="copd-clinical-examination-number-wrapper">
            <input
              type="number"
              step="any"
              name={item.key}
              value={fieldValue}
              onChange={(e) => handleInputChange(item.key, e.target.value)}
              className={`copd-clinical-examination-number-input ${hasError ? "error" : ""
                }`}
              placeholder={`Enter ${item.name.toLowerCase()}`}
              required={item.required === "yes"}
            />
          </div>
        )}

        {/* Additional info for medication history */}
        {item.additional_info && (
          <div className="copd-clinical-examination-medication-info">
            <p className="copd-clinical-examination-medication-group">
              {item.additional_info.group2}
            </p>
            <p className="copd-clinical-examination-medication-group">
              {item.additional_info.group3}
            </p>
          </div>
        )}

        {hasError && (
          <span className="copd-clinical-examination-error-message">
            {validationErrors[item.key]}
          </span>
        )}
      </div>
    );
  };

  const renderClinicalExaminations = (examinationsData) => {
    if (!examinationsData) return null;

    // Group fields in pairs for side-by-side layout
    const groupedFields = [];
    for (let i = 0; i < examinationsData.length; i += 2) {
      groupedFields.push(examinationsData.slice(i, i + 2));
    }

    return (
      <div className="copd-clinical-examination-form">
        {groupedFields.map((fieldGroup, groupIndex) => (
          <div key={groupIndex} className="copd-clinical-examination-row">
            {fieldGroup.map((item, index) => (
              <div key={index} className="copd-clinical-examination-field-side">
                {renderClinicalExaminationField(item, index)}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const openPopup = () => setIsPopupOpen(true);

  const closePopup = () => setIsPopupOpen(false);

  return (
    <OuterFrame
      hightlight="2"
      appName={"AICOPD"}
      doc_name="aicopd"
      color={props.color}
      secondaryColor={props.secondaryColor}
      surface_color={props.surface_color}
      surface_highlight_color={props.surface_highlight_color}
      surface_hover_color={props.surface_hover_color}
      button_hover_color={props.button_hover_color}
      component={
        loaderstatus || !isDataReady ? (
          <div className="loader-container">
            <Oval
              height={80}
              width={80}
              color="#4fa94d"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="medical-form">
            <div className="form-sections">
              <section className="basic-info">
                <h2 className="patient-medical-info-heading">
                  Basic Information
                </h2>
                <div className="form-grid">
                  {patientInfo?.Patient_Details.map((patient, index) => (
                    <div key={index} className="form-field-container">
                      <div className="form-field">
                        <FontAwesomeIcon
                          icon={getIconForField(patient.name)}
                          className="field-icon"
                        />
                        {patient.key === "gender" ? (
                          <select
                            value={formData.gender || ""}
                            onChange={(e) =>
                              handleInputChange("gender", e.target.value)
                            }
                            onFocus={() => handleFieldFocus(patient.key)}
                            className="gender-select"
                          >
                            <option value="" disabled>
                              Select Gender *
                            </option>
                            {patient.options.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <>
                            <input
                              type={patient.key === "email" ? "email" : "text"}
                              placeholder=""
                              value={formData[patient.key] || ""}
                              onFocus={(e) => {
                                handleFieldFocus(patient.key);
                                e.target.placeholder =
                                  getPlaceholderText(patient);
                              }}
                              onBlur={(e) => {
                                e.target.placeholder = "";
                              }}
                              onChange={(e) =>
                                handleInputChange(patient.key, e.target.value)
                              }
                            />
                            <label>
                              {patient.name}{" "}
                              {patient.required === "yes" && (
                                <span className="required">*</span>
                              )}
                            </label>
                          </>
                        )}
                      </div>
                      {validationErrors[patient.key] && (
                        <span className="error-message">
                          {validationErrors[patient.key]}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">Attributes</h2>
                {renderAttributes(
                  patientInfo?.Attributes[0]["Physical Attributes"]
                )}
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  Air Quality Index
                </h2>
                {renderAQI(patientInfo?.Attributes[1]["AQI"])}
              </section>

              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  CLINICAL PARAMETERS & HISTORY
                </h2>
                {renderClinicalParameters(
                  patientInfo?.Attributes[2]["CLINICAL PARAMETERS & HISTORY"]
                )}
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  MEDICATION HISTORY
                </h2>
                {renderMedicationHistory(
                  patientInfo?.Attributes[3]["MEDICATION HISTORY"]
                )}
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  CLINICAL EXAMINATIONS
                </h2>
                {renderClinicalExaminations(
                  patientInfo?.Attributes[4]["CLINICAL EXAMINATIONS"]
                )}
              </section>
              {/*} <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  Psychological Attributes
                </h2>
                {renderPsychologicalStress(
                  patientInfo.Attributes[2]["Psychological Attributes"]
                )}
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">Lifestyle</h2>
                {renderLifeStyle(patientInfo.Attributes[3]["Lifestyle"])}
              </section>
              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">
                  Medical History
                </h2>
                <div className="medical-form-grid">
                  {renderMedicalHistory(
                    patientInfo?.Attributes[4]["Medical History"]
                  )}
                </div>
              </section> */}
              <div className="showConcentDiv">
                <span className="DocLogoForConcentButton" onClick={openPopup}>
                  <img
                    src="/doc-icon.svg"
                    className="consent-icon"
                    alt="consent-icon"
                  />
                </span>
                <button
                  className="showConcentButton"
                  onClick={openPopup}
                  type="button"
                >
                  PATIENT INFORMATION SHEET AND INFORMED CONSENT
                </button>
              </div>
              <div className="checkBoxForTC">
                <div className="checkbox-for-patient-consent">
                  <div className="checkbox-container">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      id="loginCheckBox1"
                      checked={isChecked1}
                      onChange={() => handleCheckboxChange(1)}
                    />
                    <span className="custom-checkbox">
                      <img
                        src="/checkmark-outline-white.svg"
                        alt="checkmark-outline-white"
                      />
                    </span>
                  </div>
                  <label
                    htmlFor="loginCheckBox1"
                    className="patient-consent-label-content"
                  >
                    Patient has read and understood the information sheet, had
                    the opportunity to ask questions, and agreed to participate
                    in the NCD Risk Scores at Apollo Hospitals.
                  </label>
                </div>
              </div>
            </div>
            {warningMessage !== "" ? (
              <p className="all-fields-warning-msg">{warningMessage}</p>
            ) : null}
            <div className="submit-button-container">
              <button
                type="submit"
                className="submit-button"
                disabled={!isChecked1}
                style={{
                  opacity: !isChecked1 ? 0.5 : 1,
                  cursor: !isChecked1 ? "not-allowed" : "pointer",
                }}
              >
                Submit
              </button>
            </div>

            <PopupContainer
              isOpen={isPopupOpen}
              onClose={closePopup}
              title="STUDY PARTICIPANT INFORMATION SHEET"
            >
              <ConcentForm data={patientInfo.patient_consent} />
            </PopupContainer>
          </form>
        )
      }
    />
  );
};

export default COPDComponent;
